/**
 * @desc 导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.cabinAdvanceMaster.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinAdvanceMaster/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
